import { lazy } from "react";
import Loadable from "app/components/Loadable";
import { authRoles } from "../../../auth/authRoles";

const DtJudgementTable = Loadable(lazy(() => import("../caseLaw/App")));
const StatutesTable = Loadable(lazy(() => import("../statutes/App")));
const ActsTable = Loadable(lazy(() => import("../acts/App")));
const RulesTable = Loadable(lazy(() => import("../rules/App")));
const FormsTable = Loadable(lazy(() => import("../forms/App")));
const RateNotificationTable = Loadable(lazy(() => import("../notifications/App")));
const TariffTable = Loadable(lazy(() => import("../tariff/App")));
// const KnowledgeTable = Loadable(lazy(() => import("../knowledge/App")));
const ArticleTable = Loadable(lazy(() => import("../article/App")));
const FAQTable = Loadable(lazy(() => import("../faq/App")));
const NoticeTable = Loadable(lazy(() => import("../notice/App")));
const QueryTable = Loadable(lazy(() => import("../query/App")));

const directTaxRoutes = [
  { path: "/gst/judgements", element: <DtJudgementTable />, auth: authRoles.guest},
  { path: "/gst/judgements/:id/*", element: <DtJudgementTable />, auth: authRoles.guest },
  { path: "/gst/statutes", element: <StatutesTable />, auth: authRoles.guest},
  { path: "/gst/statutes/:id/*", element: <StatutesTable />, auth: authRoles.guest },
  { path: "/gst/acts", element: <ActsTable />, auth: authRoles.guest},
  { path: "/gst/acts/:id/*", element: <ActsTable />, auth: authRoles.guest },
  { path: "/gst/rules", element: <RulesTable />, auth: authRoles.guest},
  { path: "/gst/rules/:id/*", element: <RulesTable />, auth: authRoles.guest },
  { path: "/gst/forms", element: <FormsTable />, auth: authRoles.guest},
  { path: "/gst/forms/:id/*", element: <FormsTable />, auth: authRoles.guest },
  { path: "/gst/notifications", element: <RateNotificationTable />, auth: authRoles.guest},
  { path: "/gst/notifications/:id/*", element: <RateNotificationTable />, auth: authRoles.guest },
  { path: "/gst/tariff", element: <TariffTable />, auth: authRoles.guest},
  { path: "/gst/tariff/:id/*", element: <TariffTable />, auth: authRoles.guest },
  // { path: "/gst/knowledge", element: <KnowledgeTable />, auth: authRoles.guest},
  // { path: "/gst/knowledge/:id/*", element: <KnowledgeTable />, auth: authRoles.guest },
  { path: "/gst/article", element: <ArticleTable />, auth: authRoles.guest},
  { path: "/gst/article/:id/*", element: <ArticleTable />, auth: authRoles.guest },
  { path: "/gst/faq", element: <FAQTable />, auth: authRoles.guest},
  { path: "/gst/faq/:id/*", element: <FAQTable />, auth: authRoles.guest },
  { path: "/gst/notice", element: <NoticeTable />, auth: authRoles.guest},
  { path: "/gst/notice/:id/*", element: <NoticeTable />, auth: authRoles.guest },
  { path: "/gst/query", element: <QueryTable />, auth: authRoles.guest},
  { path: "/gst/query/:id/*", element: <QueryTable />, auth: authRoles.guest },
];

export default directTaxRoutes;
